module.exports = __webpack_public_path__ + "img/share-icon.44498b19.png";